export default __webpack_public_path__ + "static/media/Olya_Abramovich.a479f375.png";